export default "__VITE_ASSET__Ee9$XPEJ__"